import React from 'react';
import { Help } from '../../../../../_lib/Form2/partials/Help/Help';
import { TooltipPlacement } from '../../../../atoms/Tooltip';
import { createDescribedById } from '../FormLabel/utilities';
import bem from '../../../../../lib/bemUtils/bem';

type FormsFieldsetProps = {
  children?: React.ReactNode;
  className?: string;
  legend?: string;
  id?: string;
  helpText?: string;
};

export default function FormsFieldset(props: FormsFieldsetProps) {
  return (
    <fieldset className={bem(props.className || 'form-fieldset')}>
      {props.legend && (
        <legend className="form-fieldset__legend">
          <span className="form-fieldset__legend-title">
            {props.legend}
            {props.id && props.helpText && (
              <Help
                id={createDescribedById(props.id)}
                helpText={props.helpText}
                tooltipPlacement={TooltipPlacement.TOP}
              />
            )}
          </span>
        </legend>
      )}
      {props.children}
    </fieldset>
  );
}
